export const SUPER_NAV_WIDTH = 72;
export const SUB_NAV_WIDTH = 240;
export const SUB_NAV_MIN_WIDTH = 180;
export const SUB_NAV_MAX_WIDTH = 400;
